<form [formGroup]="cancelDialogForm" (ngSubmit)="save()">
  <h1 mat-dialog-title>Cancelación del turno</h1>
  <div mat-dialog-content>
      <mat-form-field class="full-control">
        <mat-select formControlName="MedicalAppointmentCancelReason" placeholder="Motivo de cancelación" required>
          <mat-option *ngFor="let medicalAppointmentCancelReason of medicalAppointmentCancelReasons" [value]="medicalAppointmentCancelReason">
            {{medicalAppointmentCancelReason.Name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="f.MedicalAppointmentCancelReason.errors && f.MedicalAppointmentCancelReason.errors.required">
          Seleccione un motivo
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-control">
        <textarea matInput placeholder="Observaciones"></textarea>
      </mat-form-field>
    </div>
  <div class="clearfix">
    <div class="pull-right">
      <button mat-button type="submit">Guardar</button>
      <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
  </div>
</form>


